import { render, staticRenderFns } from "./RenderConfig.vue?vue&type=template&id=ada55726&scoped=true&"
import script from "./RenderConfig.vue?vue&type=script&lang=js&"
export * from "./RenderConfig.vue?vue&type=script&lang=js&"
import style0 from "./RenderConfig.vue?vue&type=style&index=0&id=ada55726&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada55726",
  null
  
)

export default component.exports